<div class="shop-menu-nav-wrapper" role="navigation">
  <ul *ngIf="menuNav?.items" class="shop-menu-nav-list">
    @for (item of menuNav.items; track item._id) {
      <li>
        <shop-menu-nav-item
          [item]="item"
          [disableToggle]="!menuNav.hasSubItems"
          (itemClick)="onItemClick($event)"
          role="link"
        ></shop-menu-nav-item>
      </li>
    }
  </ul>
</div>
